import React from 'react';

function Music() {
  return (
    <div style={{ textAlign: 'center', padding: '40px', background: 'linear-gradient(135deg, #ff9a9e 0%, #fad0c4 100%)' }}>
      <h1 style={{ fontFamily: 'Dancing Script', fontSize: '40px', color: 'white' }}>
        Our Playlist
      </h1>
      <p style={{ fontSize: '30px', fontFamily: 'Dancing Script', color: 'white', marginBottom: '20px' }}>
        Some songs I've sent you or whatever 🎶💖
      </p>

      <div style={{ maxWidth: '600px', margin: '0 auto' }}>
        {/* Embed your Apple Music playlist */}
        <iframe
            title="Our Playlist"
            allow="autoplay *; encrypted-media *; fullscreen *; clipboard-write"
            height="450"
            style={{
                width: '100%',
                maxWidth: '660px',
                overflow: 'hidden',
                borderRadius: '10px',
                border: 'none',
            }}
            sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-storage-access-by-user-activation allow-top-navigation-by-user-activation"
            src="https://embed.music.apple.com/us/playlist/baby-girl/pl.u-pMrRTYla19P"
            allowFullScreen
        ></iframe>
      </div>
    </div>
  );
}

export default Music;
